import React, { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import useSound from "../../hooks/useSound";
import { stopSoundAction } from "../../redux/sound";

const Sound = () => {
  const dispatch = useDispatch();
  const audio = useRef();

  const { sound } = useSound();
  const stopSound = () => { dispatch(stopSoundAction()) };

  const {
    isPlay,
    isPause,
    ...option
  } = sound;

  useEffect(() => {
    window.addEventListener("backgroundApp", (e) => {
      stopSound();
      isPause && audio.current.pause();
      window.removeEventListener("backgroundApp", this);
    });
  }, []);

  useEffect( () => {
    play();
  }, [ isPlay ] );

  useEffect( () => {
    isPause && audio.current.pause();
  }, [ isPause ] );

  const play = async () => {
    if (isPlay) {
      await audio.current.load();
      await audio.current.play();
    }
  }
  
  return <audio ref={audio} src={option?.src} preload={option.preload} />;

};

export default Sound;
